module.exports = __webpack_public_path__ + "img/form-line.596778db.svg";